module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tradeRecords"
  }, [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop,
      "bottom-method": _vm.loadBottom,
      "bottom-all-loaded": _vm.allLoaded,
      "auto-fill": false
    }
  }, [_c('mt-header', {
    attrs: {
      "title": "交易记录"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list_wrap"
  }, _vm._l((_vm.fundList), function(fundList, index) {
    return _c('div', {
      key: index,
      staticClass: "list"
    }, [_c('div', [_c('p', [_vm._v(_vm._s(fundList.content))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(fundList.createTime)))])]), _vm._v(" "), _c('div', {
      class: {
        'output': _vm.output
      }
    }, [_vm._v(_vm._s(fundList.showBalance))])])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76d7de34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/tradeRecords.vue
// module id = 1288
// module chunks = 1